/**
 * How to run bowling brackets
 */

export const runBracketsContent = `---
id: run-brackets
title: How to run bowling brackets
description: Add a bracket on Setup, sell tickets, close sales and shuffle, then pay 1st, 2nd, and leftover refunds.
category: tournament-management
type: tutorial
estimatedTime: 6 min read
path: /support/tutorials/run-brackets
lastUpdated: 2026-09-04
version: 1.0
tags:
  - bowling-bracket-software
  - bowling-brackets
  - 8-player-brackets
  - tournament-management
seo:
  title: How to run bowling brackets | Bowling Tournament App
  description: Add a traditional 8-player bracket on Setup. Sell tickets, shuffle trees, and pay 1st, 2nd, and leftover refunds.
  keywords:
    - bowling bracket software
    - bowling tournament brackets
    - 8-player bowling brackets
    - how to run bowling brackets
---

# How to run bowling brackets

This app sells traditional 8-player bowling brackets. Scratch and handicap are separate brackets. Add them on **Setup**, then sell and shuffle on **Brackets**.

## Add a bracket

On **Setup**, add a bracket after Events. Name it. Set the ticket price, house cut, 1st, and 2nd. Scratch or handicap. Games are 1, 2, then 3.

You can add more than one bracket. Scratch $5 and Handicap $5 are two brackets.

## Sell tickets

Sell tickets on **Create Team**, **Edit Team**, or **Brackets**.

On **Brackets**, pick a squad if you are selling. Set how many tickets each bowler has. Search by name.

Ticket counts cannot change after you shuffle that squad.

## Close sales and shuffle

You need at least seven tickets on that squad. Close sales and shuffle. Trees of 8 fill first. One tree of 7 can have a first-round bye. Six or fewer leftover tickets are refunded.

Unlock shuffle if you still need to sell. Trees and leftover refunds for that squad go away.

## Scores and who to pay

Bracket games use the same scores as **Scoring**. Open **Brackets** to see the trees. 1st and 2nd show after Game 3. Leftover refunds show after shuffle.

**Prizes** on **Brackets** lists who to pay. Search by name. Summary is one row per bowler. Detail is one row per prize.

---

- [Bowling bracket software](/bowling-bracket-software)
- [How to run a bowling tournament](/support/tutorials/run-a-tournament)
- [How to create a bowling tournament](/support/tutorials/create-tournament)
`;

export default runBracketsContent;
